import {
  routePathToRegex,
  shouldReloadForVersionMismatch,
} from "@thalamos/common";

import { config } from "../../config/index.js";
import { RELOAD_SAFE_ROUTE_PATHS } from "../../routing/reloadSafeRoutes.js";

const VERSION_REFRESH_KEY = "vision-version-refresh";

const ALLOWED_PATHS = RELOAD_SAFE_ROUTE_PATHS.map(routePathToRegex);

export function checkVersionMismatch(
  serverVersion: string | null | undefined,
): void {
  if (
    !shouldReloadForVersionMismatch(
      serverVersion,
      config.version,
      window.location.pathname,
      ALLOWED_PATHS,
      localStorage.getItem(VERSION_REFRESH_KEY),
      Date.now(),
    )
  )
    return;

  localStorage.setItem(VERSION_REFRESH_KEY, String(Date.now()));
  window.location.reload();
}
